import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faEdit } from '@fortawesome/free-solid-svg-icons';
import { Card, Button, Table, Form, Modal, Alert, Row, Col } from '@themesberg/react-bootstrap';

export default () => {
    const [utilizadores, setUtilizadores] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [currentUtilizador, setCurrentUtilizador] = useState({});
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');

    // Em vez de hardcodar o URL:
    const URL_UTILIZADORES = process.env.REACT_APP_API_BASE_URL;

    // Usa concatenação simples:
    const API_BASE_URL= `${URL_UTILIZADORES}/Utilizadores`;

    const fetchUtilizadores = async () => {
        const token = localStorage.getItem("token") || sessionStorage.getItem("token");
        try {
            const response = await fetch(API_BASE_URL, {
                headers: { "Authorization": `Bearer ${token}` }
            });
            if (response.ok) {
                const data = await response.json();
                setUtilizadores(data);
            } else {
                setError('Falha ao carregar os utilizadores.');
            }
        } catch (err) {
            setError('Erro de rede ao carregar os utilizadores.');
        }
    };

    useEffect(() => {
        fetchUtilizadores();
    }, []);

    const getRole = (user) => {
        if (user.isAdmin) return 'Admin';
        if (user.isTreinador) return 'Treinador';
        if (user.isTesoureiro) return 'Tesoureiro';
        return 'E.E./Praticante';
    };

    const handleShowModal = (utilizador = null) => {
        if (utilizador) {
            // Normaliza para booleanos ao abrir o modal
            setCurrentUtilizador({
                ...utilizador,
                isAdmin: !!utilizador.isAdmin,
                isTreinador: !!utilizador.isTreinador,
                isTesoureiro: !!utilizador.isTesoureiro,
            });
        } else {
            setCurrentUtilizador({ nome: '', email: '', password: '', isAdmin: false, isTreinador: false, isTesoureiro: false });
        }
        setShowModal(true);
        setError('');
        setSuccess('');
    };

    const handleCloseModal = () => setShowModal(false);

    const handleSaveUtilizador = async (e) => {
        e.preventDefault();
        const token = localStorage.getItem("token") || sessionStorage.getItem("token");
        const isEditing = !!currentUtilizador.id;

        if (!isEditing && !currentUtilizador.password) {
            setError("A password é obrigatória para novos utilizadores.");
            return;
        }

        try {
            if (isEditing) {
                // 1. Atualiza perfil
                const profileResponse = await fetch(`${API_BASE_URL}/${currentUtilizador.id}`, {
                    method: 'PUT',
                    headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
                    body: JSON.stringify({ nome: currentUtilizador.nome, email: currentUtilizador.email })
                });
                if (!profileResponse.ok) {
                    const errorData = await profileResponse.text();
                    setError(errorData || 'Falha ao atualizar o utilizador.');
                    return;
                }

                // 2. Atualiza roles
                const rolesResponse = await fetch(`${API_BASE_URL}/${currentUtilizador.id}/roles`, {
                    method: 'PUT',
                    headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
                    body: JSON.stringify({
                        isAdmin: currentUtilizador.isAdmin ? 1 : 0,
                        isTreinador: currentUtilizador.isTreinador ? 1 : 0,
                        isTesoureiro: currentUtilizador.isTesoureiro ? 1 : 0
                    })
                });
                if (!rolesResponse.ok) {
                    const errorData = await rolesResponse.text();
                    setError(errorData || 'Falha ao atualizar as roles.');
                    return;
                }
            } else {
                // Criar novo utilizador
                const response = await fetch(`${API_BASE_URL}/register`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
                    body: JSON.stringify({
                        ...currentUtilizador,
                        isAdmin: currentUtilizador.isAdmin ? 1 : 0,
                        isTreinador: currentUtilizador.isTreinador ? 1 : 0,
                        isTesoureiro: currentUtilizador.isTesoureiro ? 1 : 0
                    })
                });
                if (!response.ok) {
                    const errorData = await response.text();
                    setError(errorData || 'Falha ao adicionar o utilizador.');
                    return;
                }
            }

            setSuccess(`Utilizador ${isEditing ? 'atualizado' : 'adicionado'} com sucesso!`);
            handleCloseModal();
            fetchUtilizadores();
        } catch (err) {
            setError('Erro de rede ao guardar o utilizador.');
        }
    };

    return (
        <>
            <div className="d-flex justify-content-between flex-wrap gap-3 align-items-start py-4">
                <div>
                    <h1 className="h4 mb-1">Gestão de Utilizadores</h1>
                    <p className="mb-0 text-muted">Faça a gestão de todos os utilizadores do sistema.</p>
                </div>
                <Button variant="primary" onClick={() => handleShowModal()}>
                    <FontAwesomeIcon icon={faPlus} className="me-2" /> Adicionar Utilizador
                </Button>
            </div>

            {success && <Alert variant="success" onClose={() => setSuccess('')} dismissible>{success}</Alert>}
            {error && <Alert variant="danger" onClose={() => setError('')} dismissible>{error}</Alert>}

            {/* Tabela — desktop */}
            <div className="d-none d-md-block">
                <Card border="light" className="shadow-sm">
                    <Card.Body className="p-0">
                        <Table hover responsive className="align-items-center mb-0">
                            <thead className="thead-light">
                            <tr>
                                <th>Nome</th>
                                <th>Email</th>
                                <th>Role</th>
                                <th>Ações</th>
                            </tr>
                            </thead>
                            <tbody>
                            {utilizadores.map(u => (
                                <tr key={u.id}>
                                    <td><span className="fw-bold">{u.nome}</span></td>
                                    <td>{u.email}</td>
                                    <td>
                                        <span className="badge bg-secondary">{getRole(u)}</span>
                                    </td>
                                    <td>
                                        <Button variant="outline-primary" size="sm" onClick={() => handleShowModal(u)}>
                                            <FontAwesomeIcon icon={faEdit} />
                                        </Button>
                                    </td>
                                </tr>
                            ))}
                            </tbody>
                        </Table>
                    </Card.Body>
                </Card>
            </div>

            {/* Cards — mobile */}
            <div className="d-md-none">
                {utilizadores.length === 0 ? (
                    <div style={{ textAlign: "center", padding: "48px 20px", background: "white", borderRadius: 16, boxShadow: "0 2px 8px rgba(0,0,0,0.06)" }}>
                        <p className="text-muted mb-0 fw-bold">Nenhum utilizador encontrado.</p>
                    </div>
                ) : utilizadores.map(u => (
                    <div key={u.id} style={{ display: "flex", alignItems: "center", gap: 14, background: "white", borderRadius: 14, padding: "14px 16px", marginBottom: 10, boxShadow: "0 2px 8px rgba(0,0,0,0.07)", border: "1px solid #f0f0f5" }}>
                        <div style={{ width: 44, height: 44, minWidth: 44, borderRadius: "50%", backgroundColor: "#1e1d45", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                            <span style={{ fontSize: 18, fontWeight: 800, color: "white" }}>{u.nome?.charAt(0).toUpperCase()}</span>
                        </div>
                        <div style={{ flex: 1, minWidth: 0 }}>
                            <div style={{ fontWeight: 700, fontSize: 15, color: "#1e1d45", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{u.nome}</div>
                            <div style={{ fontSize: 12, color: "#6c757d", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{u.email}</div>
                            <span className="badge bg-secondary mt-1" style={{ fontSize: 10 }}>{getRole(u)}</span>
                        </div>
                        <button onClick={() => handleShowModal(u)} style={{ width: 36, height: 36, borderRadius: 8, border: "1px solid #dee2e6", background: "white", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", color: "#0d6efd", flexShrink: 0 }}>
                            <FontAwesomeIcon icon={faEdit} size="sm" />
                        </button>
                    </div>
                ))}
            </div>

            {/* Modal */}
            <Modal as={Modal.Dialog} centered show={showModal} onHide={handleCloseModal}>
                <Modal.Header closeButton>
                    <Modal.Title style={{ fontSize: 16, fontWeight: 700 }}>
                        {currentUtilizador?.id ? 'Editar Utilizador' : 'Adicionar Utilizador'}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={handleSaveUtilizador}>
                        <Form.Group className="mb-3">
                            <Form.Label>Nome Completo</Form.Label>
                            <Form.Control type="text" required value={currentUtilizador.nome || ''} onChange={e => setCurrentUtilizador({ ...currentUtilizador, nome: e.target.value })} />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Email</Form.Label>
                            <Form.Control type="email" required value={currentUtilizador.email || ''} onChange={e => setCurrentUtilizador({ ...currentUtilizador, email: e.target.value })} />
                        </Form.Group>
                        {!currentUtilizador.id && (
                            <Form.Group className="mb-3">
                                <Form.Label>Password</Form.Label>
                                <Form.Control type="password" required value={currentUtilizador.password || ''} onChange={e => setCurrentUtilizador({ ...currentUtilizador, password: e.target.value })} />
                            </Form.Group>
                        )}
                        <Form.Group className="mb-3">
                            <Form.Label>Roles</Form.Label>
                            <div className="d-flex gap-3 flex-wrap">
                                <Form.Check type="checkbox" label="Admin" checked={!!currentUtilizador.isAdmin} onChange={e => setCurrentUtilizador({ ...currentUtilizador, isAdmin: e.target.checked })} />
                                <Form.Check type="checkbox" label="Treinador" checked={!!currentUtilizador.isTreinador} onChange={e => setCurrentUtilizador({ ...currentUtilizador, isTreinador: e.target.checked })} />
                                <Form.Check type="checkbox" label="Tesoureiro" checked={!!currentUtilizador.isTesoureiro} onChange={e => setCurrentUtilizador({ ...currentUtilizador, isTesoureiro: e.target.checked })} />
                            </div>
                        </Form.Group>
                        <div className="d-flex gap-2 border-top pt-3">
                            <Button variant="outline-secondary" className="flex-grow-1" onClick={handleCloseModal}>Cancelar</Button>
                            <Button variant="primary" type="submit" className="flex-grow-1">Guardar</Button>
                        </div>
                    </Form>
                </Modal.Body>
            </Modal>
        </>
    );
};
